export const AGENT_PROMOTE_LINK_LIST = 'AGENT_PROMOTE_LINK_LIST';
export const AGENT_PROMOTE_LINK_CREATE = 'AGENT_PROMOTE_LINK_CREATE';
export const AGENT_PROMOTE_LINK_SHOW = 'AGENT_PROMOTE_LINK_SHOW';
export const AGENT_PROMOTE_LINK_STATUS = 'AGENT_PROMOTE_LINK_STATUS';